import React, { useEffect } from "react";
import '@fortawesome/fontawesome-free/css/all.min.css'
import { backup } from "node:sqlite";

export const Temp_Campaign: React.FC = () => {

    useEffect(() => {
        const handleChatClick = () => {
            window.SI_API?.showPopup();
        };

        const chatButtons = document.querySelectorAll('.btn-chat');
        chatButtons.forEach(btn => btn.addEventListener('click', handleChatClick));

        return () => {
            chatButtons.forEach(btn => btn.removeEventListener('click', handleChatClick));
        };
    }, []);

    //Campagin (Prize)
    return <>
        <div className="tokyo_en">
            <section>
                <div className="banner" >
                    <div className="container">
                        <p>THE ULTIMATE REWARD</p>

                        <div className="p-3">
                            <div className="text-large">DESTINATION</div>
                            <div className="text-x-large">TOKYO</div>
                        </div>


                        <p>POWERED BY RICOH CLOUDSTREAM</p>
                        <p>An exclusive incentive experience for Ricoh’s top performers. Innovation. Culture. Connection. Unforgettable memories.</p>
                        <br />
                        <a href="#progress" className="btn">View progress</a>
                    </div>
                </div>

                <div className="container text-center">
                    <h1>More than a trip. A reward reserved for Ricoh’s top performers.</h1>
                    <p>
                        Earn your place on an unforgettable five-day experience in the heart of Tokyo, accompanied by a guest of your choice.
                    </p>
                    <p>
                        From world-class dining and iconic cultural landmarks to exclusive access inside Ricoh’s Experience Centre, this is a once-in-a-lifetime opportunity to experience one of the world’s most exciting cities.
                    </p>
                </div>

            </section>

            <section>
                <div className="container text-center">
                    <h1>Picture Yourself in Tokyo</h1>
                    <p>
                        The experiences shown offer a flavour of what your reward trip may include.*
                    </p>

                    <div className="timeline">
                        <div className="timeline-item">
                            <div>
                                <h2>Welcome to Japan</h2>
                                <p>Your adventure begins as you arrive in Tokyo and settle into premium accommodation in the heart of the city. As the lights of the skyline come to life, enjoy soaking up the atmosphere of one of the world’s most vibrant destinations.</p>
                            </div>
                            <img alt="Welcome to Japan" src="https://ricohrewards.blob.core.windows.net/public/campaigns/tokyo/Welcome%20to%20Japan.webp" />
                        </div>
                        <div className="timeline-item">
                            <div>
                                <h2>Discover Tokyo</h2>
                                <p>Spend time exploring Tokyo at your own pace. From the energy of Shibuya Crossing and the neon streets of Shinjuku to hidden temples, rooftop views and world-famous cuisine, take in everything that makes Tokyo unlike anywhere else on earth.</p>
                            </div>
                            <img alt="Discover Tokyo" src="https://ricohrewards.blob.core.windows.net/public/campaigns/tokyo/Discover%20Tokyo.webp" />
                        </div>
                        <div className="timeline-item">
                            <div>
                                <h2>Innovation & Connection</h2>
                                <p>Gain exclusive access to Ricoh’s Experience Centre and experience first-hand how technology is shaping the future of work. Meet Ricoh specialists, discover breakthrough innovations and connect with fellow top performers from across Europe.</p>
                            </div>
                            <img alt="Innovation & Connection" src="https://ricohrewards.blob.core.windows.net/public/campaigns/tokyo/Innovation%20and%20Connection.webp" />
                        </div>
                        <div className="timeline-item">
                            <div>
                                <h2>A Curated Japanese Experience</h2>
                                <p>Immerse yourself in the culture, heritage and traditions of Japan. From iconic landmarks and historic districts to authentic local experiences, enjoy a carefully curated day designed to showcase the very best of Tokyo.</p>
                            </div>
                            <img alt="A Curated Japanese Experience" src="https://ricohrewards.blob.core.windows.net/public/campaigns/tokyo/A%20Curated%20Japanese%20Experience.webp" />
                        </div>
                        <div className="timeline-item">
                            <div>
                                <h2>Memories to Last a Lifetime</h2>
                                <p>Leave with unforgettable experiences, new connections and stories you’ll be sharing long after you’ve returned.</p>
                            </div>
                            <img alt="Memories to Last a Lifetime" src="https://ricohrewards.blob.core.windows.net/public/campaigns/tokyo/Memories%20to%20Last%20a%20Lifetime.webp" />
                        </div>

                    </div>
                </div>
            </section>

            <section id="best_of_tokyo">
                <div className="container">
                    <h1>Inspired by the Best of Tokyo, Your Trip May Include*</h1>
                    <br />
                    <br />

                    <div className="row text-center">
                        <div className="col-md-6 col-xl-3">
                            <img alt="Sushi Masterclass" src="https://ricohrewards.blob.core.windows.net/public/campaigns/tokyo/Sushi%20Masterclass.webp" />
                            <h2>Sushi Masterclass</h2>
                            <p>Learn from expert chefs and experience authentic Japanese culinary art.</p>
                        </div>
                        <div className="col-md-6 col-xl-3">
                            <img alt="Bullet Train Adventure" src="https://ricohrewards.blob.core.windows.net/public/campaigns/tokyo/Bullet%20Train%20Adventure.webp" />
                            <h2>Bullet Train Adventure</h2>
                            <p>Travel Japan’s iconic high-speed network in comfort and style.</p>
                        </div>
                        <div className="col-md-6 col-xl-3">
                            <img alt="VIP Dining" src="https://ricohrewards.blob.core.windows.net/public/campaigns/tokyo/VIP%20Dining.webp" />
                            <h2>VIP Dining</h2>
                            <p>Indulge in world-class cuisine in Tokyo’s finest restaurants</p>
                        </div>
                        <div className="col-md-6 col-xl-3">
                            <img alt="Cultural Discovery" src="https://ricohrewards.blob.core.windows.net/public/campaigns/tokyo/Cultural%20Discovery.webp" />
                            <h2>Cultural Discovery</h2>
                            <p>Explore Tokyo’s rich heritage, temples, gardens and timeless traditions</p>
                        </div>

                    </div>

                    <br />
                    <br />
                    <p className="text-center">*The itinerary shown is indicative and is intended to illustrate the proposed experience. Final arrangements may vary and will be confirmed nearer the travel date.​</p>

                </div>
            </section>



        </div>
    </>

    // //Campagin (Win)
    // return <>
    //     <div className="tokyo_en">
    //         <section>
    //             <div className="banner" >
    //                 <div className="container">
    //                     <p>THE ULTIMATE REWARD</p>

    //                     <div className="p-3">
    //                         <div className="text-large">DESTINATION</div>
    //                         <div className="text-x-large">TOKYO</div>
    //                     </div>


    //                     <p>POWERED BY RICOH CLOUDSTREAM</p>
    //                     <p>An exclusive incentive experience for Ricoh’s top performers. Innovation. Culture. Connection. Unforgettable memories.</p>
    //                     <br />
    //                     <a href="#progress" className="btn">View progress</a>
    //                 </div>
    //             </div>

    //             <div className="container">
    //                 <h1>Your journey to Tokyo</h1>

    //                 <div className="process-path">
    //                     <div><h2>ENTER</h2>You’re in!</div>
    //                     <div><h2>EARN</h2>Sell eligible products</div>
    //                     <div><h2>TOKYO</h2>Experience awaits!</div>
    //                 </div>
    //                 <p>
    //                     Sell eligible RICOH CloudStream solutions between 1st October 2026 and 31st January 2027 and compete for an exclusive five-day Tokyo experience. From RICOH CloudStream to Tokyo. Every activation counts.
    //                 </p>
    //             </div>

    //         </section>



    //         <section id="how_it_works">
    //             <div className="container text-center">
    //                 <h1>How it Works</h1>
    //                 <p className="gap-3 mb-3">Earn points through eligible sales of:</p>


    //                 <div className="row mb-5 g-5">
    //                     <div className="col-12 col-lg-4">
    //                         <img alt="RICOH CloudStream Device Management" src="https://ricohrewards.blob.core.windows.net/public/campaigns/tokyo/Icon__RICOH CloudStream -Device Management.webp" />
    //                         <div>RICOH CloudStream Device Management</div>
    //                     </div>
    //                     <div className="col-12 col-lg-4">
    //                         <img alt="RICOH CloudStream Core Print" src="https://ricohrewards.blob.core.windows.net/public/campaigns/tokyo/Icon__RICOH CloudStream Core Print.webp" />
    //                         <div>RICOH CloudStream Core Print</div>
    //                     </div>
    //                     <div className="col-12 col-lg-4">
    //                         <img alt="RICOH CloudStream Embedded PrintScan" src="https://ricohrewards.blob.core.windows.net/public/campaigns/tokyo/Icon__RICOH CloudStream- Embedded PrintScan.webp" />
    //                         <div>RICOH CloudStream Embedded PrintScan</div>
    //                     </div>
    //                 </div>




    //                 <p>Points are awarded based on qualifying revenue and license activations throughout the incentive period.​</p>
    //                 <p>See <a href="./campagin/tokyo_en_terms">terms and conditions</a> for full details.</p>
    //             </div>
    //         </section>



    //         <section id="climb_rankings">
    //             <div className="container text-center">
    //                 <h1>Climb the Rankings</h1>
    //                 <p>Your performance will be measured against other participating partners across EMEA, with regular leaderboard updates helping you track your progress towards qualification. </p>
    //                 <p>At the end of the program, the highest-ranking partners will earn an unforgettable trip to Tokyo.</p>
    //                 <div className="row mt-5 g-5">
    //                     <div className="col-12 col-lg-4">
    //                         <div className="card h-100">
    //                             POINTS
    //                             <div className="text-large">XXX</div>

    //                         </div>
    //                     </div>
    //                     <div className="col-12 col-lg-4">
    //                         <div className="card h-100">
    //                             Position
    //                             <div className="text-large">XXX</div>

    //                         </div>
    //                     </div>
    //                     <div className="col-12 col-lg-4">
    //                         <div className="card h-100">
    //                             Time Remaining
    //                             <div className="text-large">XXX</div>
    //                             <small>Days to go</small>
    //                         </div>
    //                     </div>
    //                 </div>
    //             </div>
    //         </section>



    //     </div>
    // </>



};

export default Temp_Campaign;